import clientsAPI from '@/api/resources/clients'
import CrudAPI from '@/api/resources/crud'

const state = {
  all: []
}

const getters = {
  allClients: state => state.all,
  getClientById: state => (id) => {
    return state.all.find(c => c.value === id)
  }
}

const actions = {
  getAllClients ({ commit }) {
    return new Promise((resolve, reject) => {
      clientsAPI.loadClients().then(result => {
        commit('receiveClients', result)
        resolve()
      })
    })
  },
  createClient ({ commit }, clientName) {
    return new Promise((resolve, reject) => {
      CrudAPI.dfsResourceStore('clients/withid', {
        name: clientName
      }).then(result => {
        resolve(result.data.additional_data.inserted_id)
      })
    })
  }
}

const mutations = {
  receiveClients (state, clients) {
    state.all = clients
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/clients.js